// Role mapping (backend DesignationRoleMapper): Principal/Vice Principal → principal;
// Lab Assistant/Librarian → staff; all others → teacher.
export const TEACHER_DESIGNATIONS = [
  'Teacher',
  'Senior Teacher',
  'Head Teacher',
  'Vice Principal',
  'Principal',
  'Receptionist',
  'Lab Assistant',
  'Librarian',
  'Other',
];

export function designationOptions(currentValue) {
  const options = [...TEACHER_DESIGNATIONS];
  if (currentValue && !options.includes(currentValue)) {
    options.push(currentValue);
  }
  return options;
}
